import { defineMessages } from 'react-intl';

export const Floorplan = defineMessages({
  loadingLocationFloorPlan: {
    id: 'app.Floorplan.loadingLocationFloorplan',
    defaultMessage: 'Načítám půdorys lokace ...',
  },
  floorplanPhotoNotExists: {
    id: 'app.Floorplan.floorplanPhotoNotExists',
    defaultMessage: 'Fotka floorplanu neexistuje.',
  },
});
